/**
 * Tracking de eventos de voz bloqueada para usuarios Free.
 * Dual: PostHog (window.posthog si disponible) + MongoDB via API.
 * Fire-and-forget; nunca bloquea la UX.
 */
import { API_URL } from '../config/api';
import { getToken } from './authToken';

export const trackVoiceBlocked = ({ location, language = 'es' } = {}) => {
  if (!location) return;

  // 1) PostHog (cliente)
  try {
    if (typeof window !== 'undefined' && window.posthog?.capture) {
      window.posthog.capture('voice_blocked_free', { location, language });
    }
  } catch { /* ignore */ }

  // 2) MongoDB via backend (siempre disponible)
  try {
    const headers = { 'Content-Type': 'application/json' };
    const token = getToken();
    fetch(`${API_URL}/voice-blocked/track`, {
      method: 'POST',
      headers,
      credentials: 'include',
      body: JSON.stringify({ location, language }),
      keepalive: true,
    }).catch(() => {});
  } catch { /* ignore */ }
};
